import React from "react";
import gsap from "gsap";
import SplitText from "gsap/SplitText";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(SplitText, ScrollTrigger, useGSAP);

const Heading = ({ heading }: { heading: string }) => {
  const headingRef = React.useRef<HTMLHeadingElement>(null);
  useGSAP(() => {
    const headingText = new SplitText(headingRef.current, {
      type: "lines, words, chars",
    });
    gsap.from(headingText.chars, {
      scrollTrigger: {
        trigger: headingRef.current,
        start: "bottom 85%",
        toggleActions: "play none none reverse",
        once: true,
      },
      y: "8vw",
      autoAlpha: 0,
      duration: 2,
      ease: "power3.out",
      stagger: {
        amount: 0.2,
      },
    });
  }, []);
  return (
    <h2
      ref={(el) => {
        if (el) headingRef.current = el;
      }}
      className="common-heading"
    >
      {heading}
    </h2>
  );
};

export default Heading;
